// This file automatically generated by skymarshal.
// DO NOT MODIFY BY HAND!!!!
//
// From Source File: vehicle/planner/lcmtypes/movement.lcm
import Long from "long";
import Decoder from "@skydio/lcm/src/decoder";
import Encoder from "@skydio/lcm/src/encoder";
import LcmEnumMsg from "@skydio/lcm/src/enum";

enum option_t {
  UNKNOWN = 0,
  PHONE = 1,
  WAYPOINT = 2,
  SKILL = 3,
  JOYSTICK = 4,
  BEACON = 5,
  DOCK = 6,
  GPS_INITIALIZATION = 7,
  EXTERNAL_API = 9,
  TRAJECTORY_ACTION_PLANNER = 10,
}

export class movement_command_source_t extends LcmEnumMsg {
  public static override option_t = option_t;
  private static _hash = Long.fromString("11999453122282051735", true);
  private static _packed_fingerprint?: Long;

  /** @internal */
  public static override _get_packed_fingerprint(): Long {
    if (movement_command_source_t._packed_fingerprint === undefined) {
      movement_command_source_t._packed_fingerprint = movement_command_source_t._get_hash_recursive([]);
    }
    return movement_command_source_t._packed_fingerprint;
  }

  /** @internal */
  public static override _get_hash_recursive(parents: any[]): Long {
    if (parents.indexOf(movement_command_source_t) > -1) {
      return Long.fromNumber(0, true);
    }
    let tmp_hash = movement_command_source_t._hash;
    tmp_hash = tmp_hash.shl(1).add(tmp_hash.shru(63));
    return tmp_hash;
  }

  public override decode(array: Uint8Array): movement_command_source_t {
    const decoder = new Decoder(
      new DataView(array.buffer, array.byteOffset, array.byteLength)
    );
    const hash = decoder.decode_hash();
    if (!hash.equals(movement_command_source_t._get_packed_fingerprint())) {
      console.error("Hash mismatch", hash, movement_command_source_t._get_packed_fingerprint());
      throw new Error("Hash mismatch!");
    }
    this.decode_one(decoder);
    return this;
  }

  // Recursively decode a message with the supplied decoder.
  public override decode_one(decoder: Decoder): movement_command_source_t {
    this.value = decoder.decode_int32_t();
    return this;
  }

  /** @internal */
  public _get_encoded_size(): number {
    return 4;
  }

  public override encode(): ArrayBufferLike {
    const total_size = this._get_encoded_size();
    const encoder = new Encoder(total_size);
    this.encode_one(encoder);
    return encoder.view.buffer;
  }

  public override encode_one(encoder: Encoder): void {
    encoder.encode_int32_t(this.value);
  }

  // static constructors
  static get UNKNOWN() {
    return new movement_command_source_t(option_t.UNKNOWN);
  }
  static get PHONE() {
    return new movement_command_source_t(option_t.PHONE);
  }
  static get WAYPOINT() {
    return new movement_command_source_t(option_t.WAYPOINT);
  }
  static get SKILL() {
    return new movement_command_source_t(option_t.SKILL);
  }
  static get JOYSTICK() {
    return new movement_command_source_t(option_t.JOYSTICK);
  }
  static get BEACON() {
    return new movement_command_source_t(option_t.BEACON);
  }
  static get DOCK() {
    return new movement_command_source_t(option_t.DOCK);
  }
  static get GPS_INITIALIZATION() {
    return new movement_command_source_t(option_t.GPS_INITIALIZATION);
  }
  static get EXTERNAL_API() {
    return new movement_command_source_t(option_t.EXTERNAL_API);
  }
  static get TRAJECTORY_ACTION_PLANNER() {
    return new movement_command_source_t(option_t.TRAJECTORY_ACTION_PLANNER);
  }

  public override value: option_t;

  constructor(value?: option_t) {
    super();
    this.value = value ?? option_t.UNKNOWN;
  }

  public override get name(): string {
    return option_t[this.value]!;
  }
}